import {createSlice} from '@reduxjs/toolkit';
import _ from 'lodash';
import FilterBetStatusPickerComponentAction
    from '../components/AccountComponent/BettingHistoryComponent/FilterBetStatusPickerComponent/FilterBetStatusPickerComponentAction';
import {BET_TYPES, DATE_TYPE, NEW_MY_BETS_DATE_OPTION, PRODUCT_CODE, SETTLED_BETS, UNSETTLED_BETS} from '../common/Foundation';
import { CONSTANT } from '../components/AccountComponent/BettingHistoryComponent/constants';


const defaultState = {
    filterOptions: {
        page: CONSTANT.PAGE_NUMBER_DEFAULT,
        fromDate: '',
        toDate: '',
        period: NEW_MY_BETS_DATE_OPTION.ALLDATES.value,
        settledBetStatus: [],
        unSettledBetStatus: [UNSETTLED_BETS.ALL],
        selectedBetTypes: [BET_TYPES.ALL],
    selectedSports: [],
    selectedLeagues: [],
        product: PRODUCT_CODE.ALL,
        dateType: DATE_TYPE.DEFAULT,
        timeZone: 'America/Curacao' //GMT -0400
    },
    selectedSettledBets: [],
    selectedUnsettledBets: [UNSETTLED_BETS.ALL],
    isSelectedAllSettledBets: false,
    isSelectedAllUnsettledBets: false,
    searchWagerId: '',
    productInDropdown: [],
  productInQuery: {},
  sportsInDropdown: [],
  leaguesInDropdown: []
}

export const BettingHistorySlice = createSlice({
    name: 'BettingHistorySlice',
    initialState: defaultState,
    reducers: {
        onSelectBetStatus: (state, { payload = { status: {}, checked: false } }) => {
            const { status, checked } = payload
            const { value, isSettledBet } = status
            let _isSelectedAllSettledBets, _isSelectedAllUnsettledBets = false;
            let _selectedSettledBets = state.selectedSettledBets
            let _selectedUnsettledBets = state.selectedUnsettledBets

            if (checked) {
                if (isSettledBet) {
                    _selectedSettledBets.push(value)
                } else {
                    _selectedUnsettledBets.push(value)
                }
            } else {
                if (isSettledBet) {
                    _selectedSettledBets = _.filter(_selectedSettledBets, item => item !== value)
                } else {
                    _selectedUnsettledBets = _.filter(_selectedUnsettledBets, item => item !== value)

                }
            }

            const _settledBets = _.map(SETTLED_BETS, (item, index) => item.value)
            const _unSettledBets = _.map(UNSETTLED_BETS, (item, index) => item.value)

            _isSelectedAllSettledBets = FilterBetStatusPickerComponentAction.checkSelectedAll(_settledBets, _selectedSettledBets);
            _isSelectedAllUnsettledBets = FilterBetStatusPickerComponentAction.checkSelectedAll(_unSettledBets, _selectedUnsettledBets);

            state.isSelectedAllSettledBets = _isSelectedAllSettledBets
            state.isSelectedAllUnsettledBets = _isSelectedAllUnsettledBets
            state.selectedSettledBets = _selectedSettledBets
            state.selectedUnsettledBets = _selectedUnsettledBets
            state.filterOptions.page = 1;
        },
        updateAllSelectedSettledBets: (state, { payload = false }) => {
            state.isSelectedAllSettledBets = payload;
            if (payload) {
                state.selectedSettledBets = [];
            }
            state.filterOptions.page = CONSTANT.PAGE_NUMBER_DEFAULT;
        },
        updateAllUnselectedSettledBets: (state, { payload = false }) => {
            state.isSelectedAllUnsettledBets = payload;
            if (payload) {
                state.selectedUnsettledBets = [];
            }
            state.filterOptions.page = CONSTANT.PAGE_NUMBER_DEFAULT;
        },
        setSelectedSettledBets: (state, payloadAction) => {
            state.filterOptions.settledBetStatus = payloadAction.payload;
            state.filterOptions.page = CONSTANT.PAGE_NUMBER_DEFAULT;
        },
        setSelectedUnSettledBets: (state, payloadAction) => {
            state.filterOptions.unSettledBetStatus = payloadAction.payload;
            state.filterOptions.page = CONSTANT.PAGE_NUMBER_DEFAULT;
            state.filterOptions.dateType = payloadAction.payload.length > 0 ? DATE_TYPE.DEFAULT : DATE_TYPE.GRADED_DATE;
        },
        setSelectedBetTypes: (state, payloadAction) => {
            state.filterOptions.selectedBetTypes = payloadAction.payload;
            state.filterOptions.page = CONSTANT.PAGE_NUMBER_DEFAULT;
        },
      setSelectedSports: (state, payloadAction) => {
        state.filterOptions.selectedSports = payloadAction.payload;
        state.filterOptions.page = CONSTANT.PAGE_NUMBER_DEFAULT;
      },
      setSelectedLeagues: (state, payloadAction) => {
        state.filterOptions.selectedLeagues = payloadAction.payload;
        state.filterOptions.page = CONSTANT.PAGE_NUMBER_DEFAULT;
      },
        setFilterOptions: (state, payloadAction) => {
            state.filterOptions = payloadAction.payload;
            state.filterOptions.page = CONSTANT.PAGE_NUMBER_DEFAULT;
        },
        setFilterOptionsViewMore: (state, payloadAction) => {
            state.filterOptions = payloadAction.payload;
        },

        selectSettledBetFilter: (state) => {
            state.isSelectedAllSettledBets = true;
            state.isSelectedAllUnsettledBets = false;
            state.selectedSettledBets = [SETTLED_BETS.ALL];
            state.selectedUnsettledBets = [];
            state.filterOptions.page = CONSTANT.PAGE_NUMBER_DEFAULT;
            state.filterOptions.settledBetStatus = [SETTLED_BETS.ALL];
            state.filterOptions.unSettledBetStatus = [];
            state.filterOptions.dateType = DATE_TYPE.GRADED_DATE;
        },

        selectUnSettledBetFilter: (state) => {
            state.isSelectedAllSettledBets = false;
            state.isSelectedAllUnsettledBets = true;
            state.selectedSettledBets = [];
            state.selectedUnsettledBets = [UNSETTLED_BETS.ALL];
            state.filterOptions.page = CONSTANT.PAGE_NUMBER_DEFAULT;
            state.filterOptions.settledBetStatus = [];
            state.filterOptions.unSettledBetStatus = [UNSETTLED_BETS.ALL];
            state.filterOptions.dateType = DATE_TYPE.DEFAULT;
            state.filterOptions.period = NEW_MY_BETS_DATE_OPTION.ALLDATES.value;
        },
        updateSearchWagerId: (state, {payload}) => {
            state.searchWagerId = payload;
        },
        updateProductInQuery: (state, {payload}) => {
            state.productInQuery = payload;
        },
        updateProductInDropdown: (state, {payload}) => {
            state.productInDropdown = payload;
        },
      updateSportsInDropdown: (state, { payload }) => {
        state.sportsInDropdown = payload;
      },
      updateLeaguesInDropdown: (state, { payload }) => {
        state.leaguesInDropdown = payload;
      }
    }
})

export const {
    onSelectBetStatus,
    setSelectedSettledBets,
    setSelectedUnSettledBets,
    setSelectedBetTypes,
  setSelectedSports,
  setSelectedLeagues,
    setFilterOptions,
    setFilterOptionsViewMore,
    selectSettledBetFilter,
    selectUnSettledBetFilter,
    updateSearchWagerId,
    updateProductInQuery,
  updateProductInDropdown,
  updateSportsInDropdown,
  updateLeaguesInDropdown
} = BettingHistorySlice.actions;

export const selectBettingHistorySelector = state => state.BettingHistorySlice;
export default BettingHistorySlice.reducer;



// WEBPACK FOOTER //
// ./src/app/slices/BettingHistorySlice.js